<template>
    <div>
        <span class="card-title-top" style="border-bottom: 0;">
            <Row :gutter="16">
                <i-col :xs="12"><span :style="{fontSize: '24px'}">Reclamações do Canal Anônimo</span> <Badge
                        :count="rows.length" :style="{top: '-4px', left: '8px'}" overflow-count="9999" type="primary"/></i-col>
                <i-col :xs="12"><i-input @input="searchDelay" placeholder="Pesquisar" size="large"></i-input></i-col>
            </Row>
        </span>
        <TableCvs :columns="columns" :data="rows" :loading="loading">
        </TableCvs>
        <Modal
                v-model="visualizar"
                title="Responder Reclamação"
                width="500"
                ok-text="Salvar"
                @on-ok="responderReclamacao">
            <i-form label-position="top">
                <form-item label="Resumo"><Card dis-hover :padding="5">{{reclamacao.resumo}}</Card></form-item>
                <form-item label="Descrição"><Card dis-hover :padding="5"><div v-html="reclamacao.descricao"></div></Card></form-item>
                <form-item label="Resposta"><Input type="textarea" value="${resposta_gestao}" autofocus v-model="reclamacao.resposta_gestao" /></form-item>
            </i-form>
        </Modal>
    </div>
</template>

<script>
    const {moment} = require("../helpers/utils.js");
    const _ = require ("lodash");
    export default {
        name: "reclamacoes",
        components: {
            TableCvs: () => import("../components/table-csv/TableCsv")
        },
        data() {
            return {
                filtro: {
                    search: ''
                },
                loading: false,
                visualizar: false,
                reclamacao: {
                    resumo: '',
                    descricao: '',
                    resposta_gestao: ''
                },
                columns: [
                    {
                        key: 'id',
                        width: 100
                    },
                    {
                        title: 'Resumo',
                        key: 'resumo',
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        fontSize: "16px"
                                    }
                                },
                                [
                                    h(
                                        "a",
                                        {
                                            attrs: {
                                                class: "table-edit"
                                            },
                                            on: {
                                                click: () => this.verReclamacao(params.row)
                                            }
                                        },
                                        [
                                            params.row.resumo
                                        ]
                                    )
                                ]
                            );
                        }
                    },
                    {
                        title:'Código Reclamação',
                        key:'hash',
                        width:200
                    },
                    {
                        title: 'Cadastro',
                        key: 'data_hora_cadastro',
                        width: 150,
                        render: (h, params) => {
                            return h({
                                template: `<div>
                                    ${moment(params.row.data_hora_cadastro).format("DD/MM/YYYY")}
                                </div>`
                            });
                        }
                    },
                    {
                        title: "Gestão",
                        key: "analise_gestao",
                        width: 100,
                        render: (h, params) => {
                            return h("a", {
                                style: {
                                    marginLeft: "10px"
                                },
                                attrs: {
                                    class:
                                        params.row.analise_gestao === 1
                                            ? "circle-radio-checked"
                                            : "circle-radio"
                                },
                                on: {
                                    click: () =>
                                        this.analiseGestao(params.row)
                                }
                            });
                        }
                    },
                ],
                rows: []
            }
        },
        methods: {
            async getReclamacoes(query = '') {
                this.loading = true;
                try {
                    const URI = `canalanonimo?query=${query}`;
                    const {data} = await this.$axios.get(URI);
                    this.rows = data;
                    this.loading = false;
                } catch (error) {
                    console.warn(error);
                    this.$Modal.error({
                        title: "Erro!",
                        content: error
                    });
                    this.loading = false;
                }
            },
            searchDelay: _.debounce(function (val) {
                if (this.filtro.search !== val) {
                    this.filtro.search = val;
                    this.getReclamacoes(val);
                }
            }, 1000),
            verReclamacao(reclamacao) {
                this.reclamacao = reclamacao;
                this.visualizar = true;
            },
            async responderReclamacao() {
                let reclamacao = this.reclamacao;
                reclamacao.analise_gestao = reclamacao.resposta_gestao ? 1 : 0;
                const idx = _.findIndex(this.rows, o => o.id === reclamacao.id);
                try {
                    const URI = `canalanonimo/${reclamacao.id}`;
                    await this.$axios.put(URI, reclamacao);
                    this.rows.splice(idx, 1, reclamacao);
                    this.$Message.info({
                        content: 'Resposta enviada com sucesso!',
                        duration: 5,
                        closable: true
                    });
                } catch (error) {
                    console.warn(error);
                    this.$Modal.error({
                        title: 'Erro!',
                        content: error
                    });
                }
            },
            async analiseGestao(reclamacao) {
                const idx = _.findIndex(this.rows, o => o.id === reclamacao.id);
                const analise_gestao = parseInt(reclamacao.analise_gestao);
                this.rows[idx].analise_gestao = 1 - analise_gestao;
                reclamacao.analise_gestao = 1 - analise_gestao;
                try {
                    const URI = `canalanonimo/${reclamacao.id}`;
                    await this.$axios.put(URI, reclamacao);
                } catch (ex) {
                    console.warn(ex);
                    this.rows[idx].analise_gestao = analise_gestao;
                }
            },

            exportData () {
                console.log("exporting");
            }
        },
        created() {
            this.getReclamacoes();
        }
    }
</script>

<style scoped>

</style>
